export default __webpack_public_path__ + "static/media/noise.42ae936a.png";